import backofficeService from '../../api/backoffice'
import publicService from '../../api/public'

export default {
  updateLeadStudent(id, data) {
    return backofficeService.Api().put(`leadStudent/${id}`, data)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },
  addLeadStudent(data) {
    return backofficeService.Api().post(`leadStudent`, data)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },
  deleteLeadStudent(id, data) {
    return backofficeService.Api().delete(`leadStudent/${id}`, data)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },
  /**
   * Get list of products
   * @param {*} params
   * @param {*} params.limit
   * @param {*} params.offset
   * @param {*} params.search
   * @param {*} params.local Add LocalData to products
   */
  getAll(params) {
    return backofficeService.Api().get('lead', {
        params
      })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  /**
   * Get list of products
   * @param {*} params
   * @param {*} params.limit
   * @param {*} params.offset
   * @param {*} params.search
   * @param {*} params.local Add LocalData to products
   */
  getAllStudent(params) {
    return backofficeService.Api().get('leadStudent', {
        params
      })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },
  /**
   * Get specific product
   * @param {*} id
   * @param {*} params
   * @param {*} params.local Add LocalData to product
   */
  getById(id, params = {}) {
    return backofficeService.Api().get(`lead/${id}`, {
        params
      })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  leadsWithoutComment(params = {}) {
    return backofficeService.Api().get(`lead/leadsWithoutComment`, {
        params
      })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  getBusinessInformation(params) {
    return publicService.Api().get(`/public/business/info`, {
        params
      })
      .then(response => {
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },

  getPublicProductList(params) {
    return publicService.Api().get(`/public/product/info`, {
        params
      })
      .then(response => {
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },

  getPublicCampaignList(params) {
    return publicService.Api().get(`/public/campaign/info`, {
        params
      })
      .then(response => {
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },

  getPublicDepartment(params) {
    return publicService.Api().get(`/public/class/info`, {
        params
      })
      .then(response => {
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },

  getBusinessInformationbyId(params) {
    return publicService.Api().get(`/public/business/info`, {
        params
      })
      .then(response => {
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },

  async publicLeadCreate(id, data) {
    return publicService.Api().post(`public/lead?key=${id}`, data)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },



  async publicSponsorCreate(id, data) {
    return publicService.Api().post(`public/donor/createSponsor?key=${id}`, data)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  async publicCreateStripeToken(data) {
    return publicService.Api().post(`public/donor/createStripeToken`, data)
      .then(response => response.data)
      .catch((error) => {
        console.log('error', error)
        throw error
      })
  },

  async publicAddCard(data) {
    return publicService.Api().post(`public/payCompass/addCustomerCard`, data)
      .then(response => response.data)
      .catch((error) => {
        console.log('error', error)
        throw error
      })
  },

  /**
   * Create a product. Will also initiate location data
   * @param {*} data
   */
  create(data) {
    return backofficeService.Api().post('lead', data)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },
  /**
   * Update specific product
   * @param {*} id
   * @param {*} data
   */
  update(id, data) {
    return backofficeService.Api().put(`lead/${id}`, data)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },
  /**
   * Update specific product
   * @param {*} id
   * @param {*} data
   */
  convertLead(id, data) {
    return backofficeService.Api().put(`leadStudent/${id}/convert`, data)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },
  /**
   * Update specific product
   * @param {*} id
   * @param {*} data
   */
  leadStudentUpdate(id, data) {
    return backofficeService.Api().put(`leadStudent/${id}`, data)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },
  /**
   * Delete product
   * @param {} id
   * @param {*} params
   */
  delete(id, params) {
    return backofficeService.Api().delete(`lead/${id}`, {
        params
      })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

}